module.exports = __webpack_public_path__ + "static/media/shelters.b5d5997a.jpg";